// ──────────────────────────────────────────────────────────────
// Encabezado principal de la app (brand + CTA de sesión)
// El CTA es una imagen (login.png) que navega a /login
// Usa las MISMAS clases que el botón de logout.
// ──────────────────────────────────────────────────────────────

import { useNavigate } from "react-router-dom";
import { isMobile, isTablet } from "react-device-detect";
import { FaLock } from "react-icons/fa"; // Icono de candado

// Assets
// (Imagen eliminada)

// Styles (respeta el orden: Vars → Elements → Containers)
import './../../style/Vars.css';
import './../../style/ElementsStyle.css';
import './../../style/ContainersStyles.css';

import { useLogos } from "../../context/LogoProvider";

export default function Header() {
  const navigate = useNavigate();
  const { getPublicLogoUrl } = useLogos(); // Consumir contexto (Strict Public)

  const onSmallDevice = isMobile || isTablet;
  const headerClass = onSmallDevice ? "header header-mobile" : "header";
  const logoClass = onSmallDevice ? "logo logo-mobile" : "sk-brand__logo-top";

  const goLogin = () => navigate("/login");

  return (
    <header className={headerClass} role="banner">
      {/* Logo dinámico desde la BD */}
      {/* Logo dinámico desde la BD (SIEMPRE DEFAULT) */}
      {getPublicLogoUrl("Logo Principal") && (
        <img
          src={getPublicLogoUrl("Logo Principal")}
          alt="TuCoachMexico — Logo"
          className={logoClass}
          draggable={false}
          title="Tipo: Logo Principal"
        />
      )}

      {/* CTA Login Estilo Glassy (idéntico a Logout) */}
      <button
        type="button"
        className="sk-login-btn"
        onClick={goLogin}
        aria-label="Iniciar sesión"
        title="Iniciar sesión"
      >
        <span className="sk-login-icon">
          <FaLock />
        </span>
        <span className="sk-login-text">Login</span>
      </button>
    </header>
  );
}
